import { INBOX, HOWTO } from "@/data/product";
import { IMG } from "@/data/catalog";
import { mediaUrl as M } from "@/data/pdpMedia";
import { Reveal, SectionHeading } from "@/components/common/ui";

export const InBox = () => (
  <section className="bg-[#FFF0E8] py-24 md:py-32" data-testid="in-box">
    <div className="mx-auto max-w-[1200px] px-6 md:px-12">
      <SectionHeading align="center" overline="In Every Box" title="Everything you need to glow." className="mb-16" />

      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        {/* Left — image */}
        <Reveal delay={0.1} className="relative">
          <div className="overflow-hidden rounded-[2.5rem] border border-[#F2E8E6] shadow-[0_45px_100px_-44px_rgba(120,80,55,0.45)]">
            <img src={M("pdp_inbox")} data-media-slot="pdp_inbox" data-media-type="image" alt="Everything in the Leopard Luxe box" className="aspect-[4/5] w-full object-cover" />
          </div>
          <div className="absolute -bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-2xl border border-[#F2E8E6] bg-white px-4 py-3 shadow-xl">
            <span className="text-xs font-medium text-[#2C2B2C]">Arrives gift-ready in signature packaging</span>
          </div>
        </Reveal>

        {/* Right — items + value stack underneath */}
        <Reveal className="order-first space-y-8 lg:order-none">
          {INBOX.map(([t, d], i) => (
            <div key={t} className="flex items-start gap-4">
              <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-[#FBC4A8] font-display text-base text-[#232222] ring-4 ring-white">0{i + 1}</span>
              <div>
                <h3 className="font-display text-xl text-[#2C2B2C]">{t}</h3>
                <p className="mt-1 text-sm font-light leading-relaxed text-[#8A7F86]">{d}</p>
              </div>
            </div>
          ))}

          {/* Value stack */}
          <div className="flex items-center justify-between gap-6 rounded-[1.75rem] border border-[#F2E8E6] bg-white p-6 shadow-[0_30px_70px_-44px_rgba(120,80,55,0.4)]">
            <div>
              <p className="text-[0.62rem] font-semibold uppercase tracking-[0.22em] text-[#AFA295]">The complete ritual kit</p>
              <div className="mt-2 flex items-end gap-3">
                <span className="font-display text-4xl leading-none text-[#2C2B2C]">$349</span>
              </div>
              <p className="mt-2 text-sm font-light text-[#8A7F86]">Everything above, yours today.</p>
            </div>
            <span className="flex flex-none flex-col items-center rounded-2xl bg-[#FBC4A8] px-5 py-3.5 text-[#2C2B2C]">
              <span className="font-display text-xl leading-none">Free</span>
              <span className="mt-1 text-[0.58rem] font-semibold uppercase tracking-[0.18em]">express shipping</span>
            </span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export const HowToUse = () => (
  <section className="bg-[#FFFCFA] py-24 md:py-32" data-testid="how-to-use">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <SectionHeading overline="Your Daily Ritual" title="Effortless in three steps." className="mb-14" />
      <div className="grid gap-6 sm:grid-cols-3">
        {HOWTO.map(([n, t, d, img], i) => (
          <Reveal key={n} delay={i * 0.08} className="flex flex-col">
            <div className="hover-zoom relative overflow-hidden rounded-[2rem] border border-[#F2E8E6]">
              <img src={M(`pdp_howto_${i + 1}`)} alt={t} className="aspect-[3/4] w-full object-cover" />
              <span className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center bg-[#232222] font-display text-lg text-[#FFFCFA]">{n}</span>
            </div>
            <h3 className="mt-5 font-display text-2xl text-[#2C2B2C]">{t}</h3>
            <p className="mt-2 text-sm font-light leading-relaxed text-[#8A7F86]">{d}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
